// Kaomoji collection for the picker. All plain Unicode, categorized.

export type KaomojiGroup = { label: string; items: string[] };

export const KAOMOJI_GROUPS: KaomojiGroup[] = [
  {
    label: 'Happy',
    items: [
      '(≧▽≦)',
      '(o^▽^o)',
      '(＾▽＾)',
      '⸜(｡˃ ᵕ ˂ )⸝',
      '(￣▽￣)',
      '(¬‿¬)',
      '( ´ ω ` )',
      '(⌒‿⌒)',
      'ヽ(・∀・)ﾉ',
      '(☆▽☆)',
      '( ˘▽˘)っ',
      '＼(≧▽≦)／',
      '(๑˃ᴗ˂)ﻭ',
      '(*≧ω≦*)',
    ],
  },
  {
    label: 'Love',
    items: [
      '(♡°▽°♡)',
      '(´♡‿♡`)',
      '( ˘ ³˘)♥',
      '(≧◡≦) ♡',
      '♡( ◡‿◡ )',
      '(´,,•ω•,,)♡',
      '(*¯ ³¯*)♡',
      'σ(≧ε≦σ) ♡',
      '♡＼(￣▽￣)／♡',
      '(๑♡⌓♡๑)',
    ],
  },
  {
    label: 'Sad',
    items: [
      '(ノ_<。)',
      '(μ_μ)',
      '(ಥ﹏ಥ)',
      '。゜゜(´Ｏ`) ゜゜。',
      '(╥﹏╥)',
      '( ; ω ; )',
      '(个_个)',
      '(◞‸◟)',
      '｡ﾟ･ (>﹏<) ･ﾟ｡',
      '(っ˘̩╭╮˘̩)っ',
    ],
  },
  {
    label: 'Angry',
    items: [
      '(╬ Ò﹏Ó)',
      '(＃`Д´)',
      '(¬_¬")',
      'ヽ(ｏ`皿′ｏ)ﾉ',
      '(＞m＜)',
      '(￣ヘ￣)',
      '凸(￣ヘ￣)',
      '୧((#Φ益Φ#))୨',
      '(ﾉ°益°)ﾉ',
      '(¬､¬)',
    ],
  },
  {
    label: 'Shrug and confusion',
    items: [
      '¯\\_(ツ)_/¯',
      '┐(´～｀)┌',
      '(・_・ヾ',
      '(￢ ￢)?',
      '(◎ ◎)ゞ',
      'ヽ(ー_ー )ノ',
      '(・・;)ゞ',
      '┐(￣ヮ￣)┌',
      '(＠_＠)',
      '(￣～￣;)',
    ],
  },
  {
    label: 'Table flip and rage quit',
    items: [
      '(╯°□°）╯︵ ┻━┻',
      '┬─┬ノ( º _ ºノ)',
      '(ノಠ益ಠ)ノ彡┻━┻',
      '┻━┻︵ \\(°□°)/ ︵ ┻━┻',
      '(╯ಠ_ಠ)╯︵ ┳━┳',
      '(ﾉ≧∇≦)ﾉ ﾐ ┸━┸',
    ],
  },
  {
    label: 'Animals',
    items: [
      '(=^･ω･^=)',
      '(=^‥^=)',
      'ʕ •ᴥ•ʔ',
      'ʕ￫ᴥ￩ʔ',
      '(・⊝・)',
      'V●ᴥ●V',
      '(=ↀωↀ=)',
      '૮ ˶ᵔ ᵕ ᵔ˶ ა',
      '（ΦωΦ）',
      '/ᐠ｡ꞈ｡ᐟ\\',
    ],
  },
  {
    label: 'Doing things',
    items: [
      '(ง •̀_•́)ง',
      '(￣^￣)ゞ',
      'ε=ε=ε=┌(;￣▽￣)┘',
      '☕( ￣▽￣)',
      '(￣o￣) zzZ',
      '(⌐■_■)',
      'ᕕ( ᐛ )ᕗ',
      '(๑•̀ㅂ•́)و✧',
      '_(:3 」∠)_',
      '(っ▀¯▀)つ',
    ],
  },
  {
    label: 'Sparkles and celebration',
    items: [
      '(ﾉ◕ヮ◕)ﾉ*:･ﾟ✧',
      '☆*:.｡.o(≧▽≦)o.｡.:*☆',
      '✧◝(⁰▿⁰)◜✧',
      '(❁´◡`❁)',
      '*\\(^o^)/*',
      '(ﾉ´ヮ`)ﾉ*: ･ﾟ',
      '🎉(ノ^∇^)ノ',
      '♪(´▽｀)',
    ],
  },
];
